<style lang="scss">
tbody{
  td{
    padding: 6px 10px;
    padding-top: 5px;
    padding-bottom: 3px;
    border: 0;
    text-align: left;
  }
  tr:nth-child(even){
    background-color: #dae1e7;
  }
}

.logo-cliente{
  height: 150px;
}

#report{
  //margin: 5px;
  margin: auto;
  width: 838px;//595
}

.page{
  -webkit-box-shadow: 0px 0px 8px -1px #000000; 
  box-shadow: 0px 0px 8px -1px #000000;
  background: white;
  color: #666666;
  font-family: "Montserrat";
  height: 838px;//838px
  margin: auto;
  margin-bottom: 5px;
  padding:30px;
  padding-left: 70px;
  width: 590px;//590px  
}

.membrete{
  position: absolute;

  img {
    position: absolute;
    left: -70px;
    height: 798px;//800 770 horizontal 550px
  }

}

.footer{
  position: relative;
  img{
    position: absolute;
    top: 700px;//710 700 horizontal470px
    left: -15px;
  }
  div{
    position: absolute;
    top: 700px;// horizontal 470px
    left: 460px;// horizontal 715px
  }
}

.container-logo-spore{
  width: 100%;
  text-align: right;
}

.container-logo-cliente{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

#container-devices tbody{
  font-size: 10px;
}

</style>
<template>
  <div>
    <div class="vx-row my-4">
      <div class="vx-col md:w-1/4 w-full ">
        <label>{{$t('Labels.From')}}</label>
        <datepicker class="w-full" :value="filter.from" v-model="filter.from" name="from"></datepicker>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <label>{{$t('Labels.To')}}</label>
        <datepicker class="w-full" :value="filter.to" v-model="filter.to" name="to"></datepicker>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <vs-button class="mt-6" @click="getResponse()" radius color="primary" type="filled" icon="search"></vs-button>
      </div>
    </div>
    <vs-button @click="download()" color="primary" type="filled" class="my-4">{{$t('Labels.Download')}} {{$t('Labels.Report')}}</vs-button>
    <div class="w-full">
      <div id="report">
         <div class="page">
            <div class="membrete">
              <img src="@/assets/images/logo/colorbar.png" class="colorbar">
            </div>
            <div class="container-logo-spore">
              <img src="@/assets/images/logo/spore_logo_color.png">
            </div>
            <div class="footer">
              <img src="@/assets/images/logo/linkpage.png">
              <div>1/{{pagesTotal}}</div>
            </div>
            <div class="container-logo-cliente">
              <img v-show="license.company.image != null" :src="'data:image/jpeg;base64,'+license.company.image" class="mb-10 logo-cliente">
              <div class="text-center font-bold text-2xl">{{license.company.name}}</div>
              <div class="text-center text-sm">{{license.company.address}}</div>
              <div class="text-center text-sm">Licencia {{license.begin_at}} - {{license.expire_at}}</div>
            </div>
            <div>
            <table cellspancing="5" class="border-separate mt-10 m-auto">
              <tr class="">
                <td class="bg-grey-light px-4 py-1 rounded ">{{$tc('Labels.Device',2)}}:</td>
                <td class=" px-2 py-1">{{license.count_devices}}</td>
              </tr>
              <tr v-if="from.length>0">
                <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.From')}}:</td>
                <td class=" px-2 py-1">{{from.substring(0,10)}}</td>
              </tr>
              <tr v-if="to.length>0">
                <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.To')}}:</td>
                <td class=" px-2 py-1">{{to.substring(0,10)}}</td>
              </tr>
            </table>
          </div>
         </div>
         <div id="container-devices"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {jsPDF} from 'jspdf'
import Datepicker from 'vuejs-datepicker'

export default {
  components: {
    Datepicker
  },
  data () {
    return {
      filter:{
        from:'',
        to:''
      },
      license:{
        company:{
          name: '',
          image: ''
        }
      },
      from: '',
      to: '',
      devices:[],
      uuid: this.$route.params.uuid,
      html: '',
      row:0,
      numberPageLogs:1,
      pagesTotal:1,
      countRows: 20
    }
  },
  methods: {
    async getResponse () {
      this.row = 0
      this.numberPageLogs = 1
      this.pagesTotal = 1
      this.countRows = 20
      const f = new Date(this.filter.from)
      const to = new Date(this.filter.to)
      const params = {
        url: `licenses/${this.uuid}/report`,
        method: 'GET',
        params: {
          from: f.toJSON(),
          to: to.toJSON()
        }
      }
      await request(params).then(response => {
        this.license = response.data.data
        if (response.data.data.register_devices != undefined) this.setDevices(response.data.data.register_devices)
      })
      this.from = f.toJSON()
      this.to = to.toJSON()
    },
    setDevices (devices) {
      const container = document.getElementById('container-devices')
      this.html = ''
      const index = 0
      this.row = 0
      this.initPage()
      for (let index = 0; index < devices.length; index++) {
        if (this.row == this.countRows) {
          this.html += `</tbody>
                          </table>
                        </div>
                      </div>`
          this.initPage()
        }
        this.html += `<tr>  
                  <td>${devices[index].device_type}</td>
                  <td>${devices[index].serie}</td>
                </tr>`
        this.row++
      }
      container.innerHTML = this.html
    },
    initPage (name) {
      this.countRows = 20
      this.numberPageLogs++
      this.pagesTotal++
      const colorbar = require('@/assets/images/logo/colorbar.png')
      const linkpage = require('@/assets/images/logo/linkpage.png')
      const logo = require('@/assets/images/logo/spore_logo_color.png')
      this.html += `<div class="page">
          <div class="membrete">
            <img src="${colorbar}" class="colorbar">
          </div>
          <div class="container-logo-spore">
            <img src="${logo}">
          </div>
          <div class="footer">
            <img src="${linkpage}">
            <div>${this.numberPageLogs}/<span class="pagesTotal"></span></div>
          </div>
          <div class="w-full text-left">
            <div class="font-bold text-xl">${this.$tc('Labels.Device', 2)}</div>
          </div>
          <div class="p-5">
            <table class="w-full">
              <thead>
                <tr>
                  <th>${this.$t('Labels.Type')}</th>
                  <th>${this.$t('Labels.Serie')}</th>
                </tr>
              </thead>
              <tbody>`
      this.row = 2
    },
    download (err, canvas) {
      this.$vs.loading()
      this.createPDF()
    },
    createPDF () {
      const app = this
      const pdf = new jsPDF('l', 'pt', 'a4')
      pdf.setFont('helvetica')
      pdf.html(document.getElementById('report'), {
        callback (pdf) {
          const date = app.getDate()
          const name = `manager-${app.license.company.name}-${date}.pdf`
          pdf.save(name)
          app.$vs.loading.close()
        }
      })
    },
    getDate () {
      const today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1 
      const yyyy = today.getFullYear()
      if (dd < 10) dd = `0${  dd}`

      if (mm < 10) mm = `0${  mm}`
      
      return `${dd}/${mm}/${yyyy}`
    }
  },
  mounted () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Licenses')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Report')
    this.$route.meta.pageTitle = this.$t('Path.Report')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },
  watch:{
    numberPageLogs (val) {
      const e = document.querySelectorAll('.pagesTotal')
      e.forEach(element =>  element.innerHTML = this.pagesTotal)  
    }
  }
}
</script>  